import { useEffect, useState } from "react";

const ShareControl = () => {
  const [copied, setCopied] = useState(false);
  const [url, setUrl] = useState(window.location.href);

  const updateUrlState = () => {
    setUrl(window.location.href);
  };

  useEffect(() => {
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = (...args) => {
      originalPushState.apply(window.history, args);
      updateUrlState();
    };

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(window.history, args);
      updateUrlState();
    };

    return () => {
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  const copyURL = (e) => {
    navigator.clipboard.writeText(url)
      .then(() => {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      })
      .catch((err) => console.error("Error copying the URL:", err));
    e.currentTarget.blur();
  };

  return (
    <div className="share-container">
      <div className="widget-text">
        Copy and paste this link to share the map URL
      </div>
      <div>
        <div className="widget-input share-input">
          <i className="fa-solid fa-link"></i>
          <input 
            type="text" 
            className="ccl-text-input" 
            value={url}
            placeholder="Map viewer URL"
            readOnly
          />
        </div>
        <button className="ccl-button ccl-button--default" onClick={(e) => copyURL(e)} aria-label="Copy">
          {copied ? (
            <>
              <i className="fa-solid fa-check"></i>
              <span>Copied</span>
            </>
          ) : (
            <span>Copy</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default ShareControl;
